import React, { Component } from 'react';

export default class FlaggedModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flaggedReason: this.props.job.flagged ? this.props.job.flagged_reason : '',
            originalReason: this.props.job.flagged ? this.props.job.flagged_reason : '',
            isDisabled: true,
        };
    }

    handleInputChange = (e) => {
        const newValue = e.target.value;
        const noChanges = newValue === this.state.originalReason;

        this.setState({
            flaggedReason: newValue,
            isDisabled: !newValue || noChanges,
        });
    };

    updateFlag = (e) => {
        e.stopPropagation();

        let formData = new FormData();
        formData.append('flagged_reason', this.state.flaggedReason);

        axios
            .post(`/jobs/${this.props.job.id}/set-flag`, formData)
            .then((res) => {
                toastr.success('Flag updated');
                window.location.reload();
            })
            .catch((err) => {
                toastr.error('There was a problem, please try again');
            });
    };

    removeFlag = (e) => {
        e.stopPropagation();

        axios
            .post(`/jobs/${this.props.job.id}/remove-flag`)
            .then((res) => {
                toastr.success('Flag removed');
                window.location.reload();
            })
            .catch((err) => {
                toastr.error('There was a problem, please try again');
            });
    };

    render() {
        return (
            <div
                className="admin-notes-modal"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className="admin-notes-modal-body">
                    <div className="admin-modal-content">
                        <h4>{this.props.job.flagged ? 'Flagged' : 'Add Flag'}</h4>
                        <hr />
                        <div className="form-group col-md-4">
                            <label htmlFor="flaggedReason">Reason for Flag</label>
                            <textarea
                                id="flaggedReason"
                                name="flaggedReason"
                                rows="6"
                                cols="50"
                                value={this.state.flaggedReason}
                                onChange={this.handleInputChange}
                            ></textarea>
                        </div>
                        <div className="form-group">
                            <button
                                className="btn btn-cw-primary ml-2"
                                onClick={(e) => this.updateFlag(e)}
                                disabled={this.state.isDisabled}
                            >
                                Update
                            </button>
                            {this.props.job.flagged ? (
                                <button className="btn btn-cw-primary ml-2" onClick={(e) => this.removeFlag(e)}>
                                    Remove Flag
                                </button>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <hr />
                    <div className="admin-notes-modal-footer">
                        <button className="btn btn-cw-primary" onClick={(e) => this.props.onHide(e, false, null)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
